import { render, staticRenderFns } from "./EventHome.vue?vue&type=template&id=0a1adfae&scoped=true"
import script from "./EventHome.vue?vue&type=script&lang=js"
export * from "./EventHome.vue?vue&type=script&lang=js"
import style0 from "./EventHome.vue?vue&type=style&index=0&id=0a1adfae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1adfae",
  null
  
)

export default component.exports